// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__VDFbL","mainSection":"styles_mainSection__u0oq-","sweepSection":"styles_sweepSection__ZCK6g"};